import { Autoplay, Navigation } from 'swiper';
import { swiperOnResize } from '../../utils/swiperOnResize.utils.js';

let ourOfficesSwiperWr = document.querySelectorAll('.our-offices-swiper-wr');
ourOfficesSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    swiperOnResize('(max-width: 768px)', swiperEl,
        {
          modules: [Autoplay, Navigation],
          slidesPerView: 1,
          spaceBetween: 16,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
        breakpoints: {
          400: {
            spaceBetween: 16,
            slidesPerView: 1.2,
          },
          480: {
            spaceBetween: 16,
            slidesPerView: 1.5,
          },
          600: {
            spaceBetween: 18,
            slidesPerView: 2,
          },
        },
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
        },
    );
  }
});